<template>
  <v-app>
    <RouterView />
  </v-app>
</template>

<script>
import { useShellHost } from '@/services/shellHost'

export default {
  name: 'App',
  setup () {
    // Above every route, so the shell layout and the popup sign-in landing, which is
    // routed outside it, read the same environment.
    useShellHost()
  }
}
</script>
